import React, { useEffect, useState } from 'react';
import Form from '../../../../np-form/Form';
import { Dialog, withStyles } from '@material-ui/core';
import * as formUtility from '../../../../np-form/utility';
import moment from 'moment'
import { Redirect } from 'react-router-dom';
import { snackActions } from '../../../../sc-utilities/SnackBar';
import History from "../../../../../History";
import { checkIfLoading, hasPermission } from '../../../../sc-utilities';
import AppLogoLoading from '../../../../sc-logo';

const styles = theme => ({
    root: {

        padding: '6px',
        width: '91%',
        paddingLeft: '5%'
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
      },
});

const AdminCreate = props => {
    const { classes, translations, setActiveStep, setCustomers, userFormValid, activeCustomer, setUserFormValid, setUserFormValue, userFormValue, onCheckFormParams, permissions=[], fetchGroups } = props;

    if (userFormValue.Status && userFormValue.Status.value === 1) {
        userFormValue.Status.value = 'active'
    } else if (userFormValue.Status && userFormValue.Status.value === 0) {
        userFormValue.Status.value = 'inactive'
    }

    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState({groups: false});

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    useEffect(() => {
        const getGroups = async () => {
          setLoading(prevState => { return {...prevState, groups: true} });
          const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomer});
          if (resultGroups?.data) {
              setGroups(resultGroups.data.map((group) => ({value: group.GroupID, displayValue: group.Name})));
          }
          setLoading(prevState => { return {...prevState, groups: false} });
      }
    
        if (hasPermission(permissions, 'group_list')) {
          getGroups();
        }
        // eslint-disable-next-line
      }, []);

    const firstForm = {
        FirstName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['first_name'] || 'First name',
                label: translations['first_name'] || 'First name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        LastName: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['last_name'] || 'Last name',
                label: translations['last_name'] || 'Last name',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        Username: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['username'] || 'Username',
                label: translations['username'] || 'Username',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true,
                error: userFormValue.error === "Username"
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        Email: {
            elementType: 'input',
            elementConfig: {
                type: 'email',
                placeholder: translations['e_mail'] || 'E-Mail',
                label: translations['e_mail'] || 'E-Mail',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: false,
                isEmail: true
            },
            valid: true,
            touched: false
        },
        Position: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['user_position'] || 'Position',
                className: classes && classes.inputs ? classes.inputs : null,
                label: translations['user_position'] || 'Position',
                error: false,
                fullWidth: true
            },
            value: '',
            validation: {
                required: false
            },
            valid: false,
            touched: true
        },
        PhoneNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: translations['phone_number'] || 'Phone number',
                className: classes && classes.inputs ? classes.inputs : null,
                label: translations['phone_number'] || 'Phone number',
                error: false,
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: true
        },
        Password: {
            elementType: 'password',
            elementConfig: {
                type: 'password',
                placeholder: translations['password'] || 'Password',
                label: translations['password'] || 'Password',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        RepeatPassword: {
            elementType: 'password',
            elementConfig: {
                type: 'password',
                placeholder: translations['password_repeat'] || 'Password repeat ',
                label: translations['password_repeat'] || 'Password repeat ',
                className: classes && classes.inputs ? classes.inputs : null,
                margin: "dense",
                error: false,
                fullWidth: true
            },
            value: '',
            validation: {
                required: true
            },
            valid: false,
            touched: false
        },
        Status: {
            elementType: 'select_v2',
            elementConfig: {
                id: "userStatus",
                fullWidth: true,
                options: [{ value: 'active', displayValue: translations['active'] || 'Active' }, { value: 'inactive', displayValue: translations['inactive'] || 'Inactive' }]
            },
            value: 'active',
            validation: {},
            valid: true,
            formHelperText: translations['please_select_status'] || 'Please select status'
        },
        PasswordExpires: {
            elementType: 'checkbox',
            elementConfig: {
                type: 'checkbox',
                label: null,
                className: null,
                margin: "dense",
                fullWidth: true,
                options: [{ ID: 'checkboxID', Checked: false, Name: translations['user_to_change'] || "Force user to change password" }]
            },
            value: false,
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        UserSuperAdmin: {
            elementType: 'checkbox',
            elementConfig: {
                type: 'checkbox',
                label: null,
                className: null,
                margin: "dense",
                fullWidth: true,
                options: [{ ID: 'checkboxID', Checked: false, Name: `${translations['user_create_super_admin'] || "Do you want to create a super user account"}?` }]
            },
            value: false,
            validation: {
                required: false
            },
            valid: true,
            touched: false
        },
        GroupID: {
            elementType: 'select_v2',
            elementConfig: {
                id: "userGroup",
                fullWidth: true,
                options: hasAccessAllGroupsPermission? [{value: null, displayValue: translations['none'] || "None"}, ...groups || []] || [] : groups || []
            },
            value: hasAccessAllGroupsPermission? null : groups?.length>0? groups[0].value : null,
            validation: {},
            valid: true,
            formHelperText: translations['please_select_group'] || 'Please select group'
        },
    };

    const firstFormWithGroupID = {...firstForm};

    if (groups.length<1) {
        delete firstFormWithGroupID["GroupID"]
    }

    const [userForm, setUserForm] = useState(Object.keys(userFormValue).length > 0 ? userFormValue : firstFormWithGroupID);
    const [superAdmin, setSuperAdmin] = useState(false);

    useEffect(() => {
        setUserForm(Object.keys(userFormValue).length > 0 ? userFormValue : firstFormWithGroupID);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groups])

    const userFormInputChangedHandler = (event, inputIdentifier) => {

        const updateState = formUtility.getNewStateOnInputChange(event, inputIdentifier, userForm);

        if (Object.keys(userFormValue).length > 0 && userFormValue.Username && userFormValue.Username.elementConfig.error === true) {
            updateState.myForm['Username'].elementConfig.error = userFormValue['Username'].value === updateState.myForm['Username'].value
        }
        setUserForm(updateState.myForm);
        if (updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value && (updateState.myForm.RepeatPassword.value !== '' || updateState.myForm.Password.value !== '')) {
            updateState.formIsValid = false;
        }

        if (inputIdentifier === 'Password' && updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value) {
            updateState.formIsValid = false;
        }
        if (inputIdentifier === 'Username') {
            if (
                updateState.myForm.Username.value === 'root' || 
                updateState.myForm.Username.value.includes("@") ||
                /\s+/.test(updateState.myForm.Username.value)
            ) {
                updateState.formIsValid = false;
                setUserForm({ ...updateState.myForm, Username: { ...updateState.myForm.Username, elementConfig: { ...updateState.myForm.Username.elementConfig, error: true } } })
            }
            else {
                setUserForm({ ...updateState.myForm, Username: { ...updateState.myForm.Username, elementConfig: { ...updateState.myForm.Username.elementConfig, error: false } } })
            }
        }
        if (inputIdentifier === 'Email') {
            setUserForm({ ...updateState.myForm, Email: { ...updateState.myForm.Email, elementConfig: { ...updateState.myForm.Email.elementConfig, error: !updateState.myForm.Email.valid } } })
        }

        if (inputIdentifier === 'RepeatPassword') {
            setUserForm({ ...updateState.myForm, RepeatPassword: { ...updateState.myForm.RepeatPassword, elementConfig: { ...updateState.myForm.RepeatPassword.elementConfig, error: updateState.myForm.RepeatPassword.value !== updateState.myForm.Password.value } } })
        }
        setUserFormValid(updateState.formIsValid);
    };
    const checkboxChangedHandler = (event, inputIdentifier) => {
        const updateState = formUtility.getNewStateOnCheckboxChange(event, inputIdentifier, userForm);
        if (inputIdentifier === 'UserSuperAdmin') {
            setSuperAdmin(updateState.myForm.UserSuperAdmin.value)
        }
        setUserForm(updateState.myForm);

    }
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '' });

    const submitHandler = async event => {

        event.preventDefault();
        const formUser = formUtility.getFormData(userForm);
        formUser.Status = formUser.Status === 'active' ? 1 : 0;
        formUser.PasswordExpires = formUser.PasswordExpires ? moment().utc() : null;

        // Calling check...
        let checkResponse = await onCheckFormParams({
            ActiveCustomerID: activeCustomer,
            Email: formUser.Email,
        })

        if (checkResponse && checkResponse.status !== 200 && checkResponse.error && checkResponse.error.errorKey) {
            snackActions.snackBarComponent(checkResponse.message, "warning")
            setUserForm({ ...userForm, [checkResponse.error.errorKey]: { ...userForm[checkResponse.error.errorKey], elementConfig: { ...userForm[checkResponse.error.errorKey].elementConfig, error: true } } })
            setUserFormValid(false)
            return
        }

        if (superAdmin) {
            props.onCreateUser({ UserDetails: { ...formUser }, SuperUser: true, ActiveCustomerID: activeCustomer, GroupID: formUser["GroupID"] })
            setRedirectOptions({ redirect: true, redirectPath: `/account-management/users` });
        }
        else {
            setUserFormValue(userForm)
            let customer = await props.onFetchCustomers({ ActiveCustomerID: activeCustomer });
            setCustomers(customer)
            setActiveStep(1)
        }
    };
    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const cancelHandler = () => {
        History.goBack();
    };

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{classes: {root: classes.loading}}}>
    <AppLogoLoading />
  </Dialog>


    return (
        <>
        {checkIfLoading(loading)? loadingScreen : <Form
            formIsValid={userFormValid}
            classes={classes}
            form={userForm}
            inputChangedHandler={userFormInputChangedHandler}
            checkboxChangedHandler={checkboxChangedHandler}
            submitHandler={submitHandler}
            submitButtonColor={'primary'}
            buttonText={superAdmin ? translations["save"] || 'SAVE' : translations["next"] || 'NEXT'}
            submitButtonStyle={userFormValid ? { color: "#fafafa", borderRadius: '1px' } : { borderRadius: '1px' }}
            cancelHandler={cancelHandler}
            buttonTextCancel={translations["cancel"] || 'Cancel'}
        />}
        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminCreate);




